// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"247100e6","226":"07fc25fa","250":"fd69f0d4","269":"af919065","373":"5138c3a2","452":"bb4b8dab","453":"72b05023","586":"ed6271f3","688":"957be4a3","902":"38c97d42"}[chunkId] + ".chunk.js";
};